(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').service('mx.SolutionBuilderAgent.ConditionsBuilder.Enums', ConditionsBuilderEnums);
	ConditionsBuilderEnums.$inject = ['mx.utils.MxEnum'];

	function ConditionsBuilderEnums(MxEnum) {
		const ComplianceRuleTriggerTypes = new MxEnum({
			CreateObject: 1,
			DeleteObject: 2,
			Action: 3,
			ChangeObject: 5,
			External: 6,
		});

		const ComplianceRuleConditionStart = new MxEnum({
			After: 0,
			Before: 1,
		});

		const ConditionTypes = new MxEnum({
			Boolean: 1,
			Date: 2,
			Expression: 3,
			String: 4,
			ObjectReference: 5,
			EnumerationReference: 6,
			Fragment: 7,
			ObjectReferences: 8,
			Number: 9,
			MultiFragment: 10,
		});

		const ConditionValueTypes = new MxEnum({
			Value: 0,
			Attribute: 1,
			Expression: 2,
		});

		const ConditionBuilderMode = new MxEnum({
			enableDifferentOperatorsInGroup: 0, // CoRu oldUi
			disableDifferentOperatorsInGroup: 1, // CoRu newUi
		});

		const ConditionLogicOperators = new MxEnum({
			AND: 0,
			OR: 1,
		});

		const ConditionDateMods = new MxEnum({
			Date: 'date',
			DateExpression: 'dateExpression',
		});

		return {
			ComplianceRuleTriggerTypes: ComplianceRuleTriggerTypes,
			ComplianceRuleConditionStart: ComplianceRuleConditionStart,
			ConditionTypes: ConditionTypes,
			ConditionValueTypes: ConditionValueTypes,
			ConditionBuilderMode: ConditionBuilderMode,
			ConditionLogicOperators: ConditionLogicOperators,
			ConditionDateMods: ConditionDateMods,
		};
	}
})();
